import React from "react";

export default function About() {
  return <div className="mt-5">ABOUT US</div>;
}
